// hooks/useFormattedImageUrl.js

import { useMemo } from "react";

const useFormattedImageUrl = (rawUrl) => {
  const formattedUrl = useMemo(() => {
    if (!rawUrl) return "";

    let url = rawUrl.trim();

    // Add protocol if missing
    if (!/^https?:\/\//i.test(url)) {
      const isHttps = typeof window !== "undefined" && window.location.protocol === "https:";
      url = (isHttps ? "https://" : "http://") + url.replace(/^\/+/, "");
    }

    // Remove double slashes (except after protocol)
    url = url.replace(/([^:]\/)\/+/g, "$1");

    return url;
  }, [rawUrl]);

  return formattedUrl;
};

export default useFormattedImageUrl;
